function constructCNNBar() {
    function initCNNBar() {

        // Setup social share menu
        var shareEl = barEl.querySelector('[data-share]');
        var shareToggleEl = barEl.querySelector('[data-share-toggle]');

        if(shareToggleEl) {
        shareToggleEl.addEventListener('click', function(){
            if(shareEl.classList.contains('cnn-header__share--active')){
            shareEl.classList.remove('cnn-header__share--active');
            } else {
            shareEl.classList.add('cnn-header__share--active');
            }
        }, false);
        }

        // Set up scroll handler
        document.addEventListener('scroll', function() {
        window.requestAnimationFrame(onScroll);
        }, {passive: true});

    }

    function onScroll() {
        // Get current scroll position
        var sPos = typeof window.scrollY === 'undefined' ? window.pageYOffset : window.scrollY;

        if(sPos < 30) {
        if(barEl.classList.contains('cnn-header--fixed')) {
            barEl.classList.remove('cnn-header--fixed');
        }
        } else {
        if(!barEl.classList.contains('cnn-header--fixed')) {
            barEl.classList.add('cnn-header--fixed');
        }
        }
    }

    // Get main element
    var barEl = document.getElementById('cnn-header');
    if(barEl) {
        initCNNBar();
    }
}

export default () => {
    constructCNNBar();
}